import { STYLE_DARK, STYLE_GRADIENT } from '@eventbrite/eds-progress-indicator';
import { HAS_WINDOW } from '@eventbrite/feature-detection';

export const DEFAULT_STYLES = 'default';
export const REBRANDING_STYLES = 'rebranding';

export const getStyles = (isRebrandingEnabled: boolean) =>
    isRebrandingEnabled ? REBRANDING_STYLES : DEFAULT_STYLES;

export const getFooterHeight = () => {
    if (!HAS_WINDOW) {
        return 0;
    }

    return (
        document?.getElementsByClassName('eds-modal__footer')[0]
            ?.scrollHeight || 0
    );
};

export const getOrderSummaryHeight = () => {
    if (!HAS_WINDOW) {
        return 0;
    }

    return (
        document?.getElementById('order-summary-container')?.scrollHeight || 0
    );
};

export const getIsOrderSummaryBiggerThanScreen = (
    orderSummaryHeight: number,
    footerHeight = 0,
) => {
    if (!HAS_WINDOW) {
        return false;
    }

    // Leaving a margin above the order summary to make sure it is not too close to the top being a modal
    const marginTop = 24;
    return orderSummaryHeight + marginTop > screen.height - footerHeight;
};

export const getLoadingOverlayStyle = (isAppRebrandActive: boolean) =>
    isAppRebrandActive ? STYLE_DARK : STYLE_GRADIENT;
